const HEADERS = ['Nome', 'CEP Inicial', 'CEP Final'];

export default HEADERS;
